module.exports = __webpack_public_path__ + "img/img_ring.44c72e85.svg";